import { render } from "./CustomIcon.vue?vue&type=template&id=c7cc9494"
import script from "./CustomIcon.vue?vue&type=script&lang=js"
export * from "./CustomIcon.vue?vue&type=script&lang=js"
script.render = render

export default script